import i18nIsoCountries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'

i18nIsoCountries.registerLocale(en)

const SIZE_MULTIPLIER = 3
const ZOOM_BREAKPOINT = 8

const countries = i18nIsoCountries
const geoUrl = '/world-110m-241.json'
const globalCountryRate = {}
const userCountryRate = {}
const map = {
    countryLabelFontSize: 4 * SIZE_MULTIPLIER,
    cityMarkerRadius: 2 * SIZE_MULTIPLIER,
    cityMarkerStrokeWidth: 0.8 * SIZE_MULTIPLIER,
    cityLabelFontSize: 4 * SIZE_MULTIPLIER,
    cityDateFontSize: 4 * SIZE_MULTIPLIER,
    cityLabelOffsetX: 3.5 * SIZE_MULTIPLIER,
    padding: 110,
    fontFamily: '"OpenSansCondensed-Light", serif',
}
const zoom = {
    breakpoint: ZOOM_BREAKPOINT,
    min: 1,
    max: 64,
    fitMaxZoom: 6,
    zoomInMultiplier: 1.2,
    zoomOutMultiplier: 1.2,
    wheelZoomFactor: 1.15,
}
const labelPositionOverrides = {
    'France': [2.5, 46.5],
    'United States of America': [-98.0, 39.0],
    'United Kingdom': [-2.0, 54.0],
    'Denmark': [10.0, 56.0],
    'Netherlands': [5.5, 52.5],
    'Russia': [100.0, 62.0],
}
const labelOverrides = {
    'Czechia': 'Czech Republic',
    'S. Sudan': 'South Sudan',
    'North Macedonia': 'The Republic of North Macedonia',
    'Antigua and Barb.': 'Antigua and Barbuda',
    'Bosnia and Herz.': 'Bosnia and Herzegovina',
    'Central African Rep.': 'Central African Republic',
    'Dominican Rep.': 'Dominican Republic',
    'Eq. Guinea': 'Equatorial Guinea',
    'eSwatini': 'Eswatini',
    'Marshall Is.': 'Marshall Islands',
    'Micronesia': 'Micronesia (Federated States of)',
    'St. Kitts and Nevis': 'Saint Kitts and Nevis',
    'St. Vin. and Gren.': 'Saint Vincent and the Grenadines',
    'S\u00e3o Tom\u00e9 and Principe': 'Sao Tome and Principe',
    'Solomon Is.': 'Solomon Islands',
}
const colors = {
    visitedColor: '#000000',
    defaultColor: 'none',
    hoveredVisitedColor: '#111',
    hoveredColor: 'rgba(0,0,0,.10)',
    hoveredFill: 'var(--surface-base)',
    selectedStroke: 'var(--primary-color)',
    defaultStroke: '#555',
    visitedStroke: '#aaa',
    visitedHoveredStroke: '#fff',
    cityDefaultStroke: 'white',
}
const strokeWidths = {
    default: 0.1,
    visited: 0.2,
    selected: 0.3,
}
const hiddenCountries = []

export const worldMapConfig = {
    displayAboveGrid: true,
    countries,
    geoUrl,
    globalCountryRate,
    userCountryRate,
    map,
    zoom,
    labelPositionOverrides,
    labelOverrides,
    colors,
    strokeWidths,
    hiddenCountries,
    zoomControlsEnabled: false
}
